import { IconProps } from ".";

export const CubeIcon: React.FC<IconProps> = (props) => {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.4133 5.81135V10.1881C13.4133 10.768 13.1039 11.3041 12.6018 11.594L8.81128 13.7821C8.30915 14.0727 7.69015 14.0727 7.18802 13.7821L3.39757 11.594C2.89544 11.3041 2.58594 10.768 2.58594 10.1881V5.81135C2.58594 5.23151 2.89544 4.69543 3.39757 4.40552L7.18802 2.21744C7.69015 1.92752 8.30915 1.92752 8.81128 2.21744L12.6018 4.40552C13.1039 4.69543 13.4133 5.23151 13.4133 5.81135Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 13.9655V8.01953"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1486 5.04361L7.99935 8.01638L2.84961 5.04297"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
